import React from 'react'
import { Link } from 'gatsby'
import Top from '../components/Topbar'
import Seo from '../components/Seo'
import { defineCustomElements as deckDeckGoHighlightElement } from '@deckdeckgo/highlight-code/dist/loader';
import { Helmet } from 'react-helmet'
import '../styles/style.scss'

deckDeckGoHighlightElement();

export default function Home() {
  return (
    <div className="home">
      <Seo/>
      <Helmet>
        <html lang="es"></html>
        <title>Cristóbal Villanueva | Geólogo y Desarrollador Web</title>
      </Helmet>
      <Top/>
      <nav>
        <Link to="/proyectos">
          <div>proyectos</div>  
        </Link>
        <Link to="/competencias">competencias</Link>
        <Link to="/blogs">blog</Link>
        <Link to="/about">acerca de mí</Link>
      </nav>
    </div>
  )
}
